import { render, staticRenderFns } from "./task-status-card.vue?vue&type=template&id=63b061d2&scoped=true"
import script from "./task-status-card.vue?vue&type=script&lang=js"
export * from "./task-status-card.vue?vue&type=script&lang=js"
import style0 from "./task-status-card.vue?vue&type=style&index=0&id=63b061d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b061d2",
  null
  
)

export default component.exports